import React from "react";
import ModernOptionCard from "../ModernOptionCard/ModernOptionCard.jsx";
import { ChantButton } from "../../../../../../CommonComponents/index.js";
import HelpTooltip from "../../../../../../CommonComponents/HelpTooltip/HelpTooltip.jsx";
import "./ModernOnboardOptions.css";
import Option4 from "./Option4/Option4.jsx";
import Option1 from "./Option1/Option1.jsx";

const ModernOnboardOptions = ({
  regCodeRole,
  isRoleSaving,

  handleTabChange,
  // Option 3 props
  downloading,
  registrationLink,
  // Option 4 props
  isLoading,
  showModal,
  editStatus,

  // Option 4 methods
  saveRegCodeRole,
  handleChangeRegistrationCode,
  onShowModal,
  onCloseModal,
  onOpenModal,
}) => {
  return (
    <div className="onboard-sections">
      {/* Section 1: Members - Options 1-3 */}
      <div className="onboard-section members-section">
        <div
          className="section-header"
          style={{ backgroundColor: "var(--primary-background)" }}
        >
          Members
        </div>
        <div className="section-cards members-cards">
          <div className="modern-onboard-container">
            <div className="options-grid">
              {/* Option 1: Add Individual */}
              <Option1 />

              {/* Option 2: Bulk Upload */}
              <ModernOptionCard
                title="Option 2"
                subtitle="Bulk Upload"
                icon={<i className="fa fa-upload" />}
              >
                <div className="description-section">
                  <p>
                    To pre-register your full member list, upload a CSV file
                    with names and emails{" "}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <a
                        href="https://docs.google.com/spreadsheets/d/1Qpqa7I64ELQaAdB1tuJ08OQgvRqVpgHTIqpIFnTSGzI/edit?usp=sharing"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        (copy template){" "}
                      </a>{" "}
                      <span>
                        <HelpTooltip
                          text={
                            <div>
                              <div
                                style={{
                                  marginBottom: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                CSV Import Guide:
                              </div>
                              <div style={{ lineHeight: "1.6" }}>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong>a)</strong> Make a copy of template
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong>b)</strong> Do not change columns /
                                  column names
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong>c)</strong> Ensure emails are unique
                                </div>
                                <div>
                                  <strong>d)</strong> Use File / Download / CSV
                                  to create file for import
                                </div>
                              </div>
                            </div>
                          }
                          color="#666"
                        />
                      </span>
                    </span>
                  </p>
                </div>

                <div className="link-section">
                  <div style={{ textAlign: "center" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        display: "block",
                        marginBottom: "12px",
                      }}
                    >
                      Full Data Import
                    </span>
                    <p>
                      Want to import your full member database (all fields)?
                    </p>
                    <p>
                      Reach out to{" "}
                      <a
                        style={{
                          color: "var(--primary-background-darker)",
                          textDecorationColor: "#ffffff",
                          textDecoration: "underline",
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="mailto:support@chant.fan"
                      >
                        support@chant.fan
                      </a>
                    </p>
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <ChantButton onClick={onShowModal}>Upload</ChantButton>
                </div>
              </ModernOptionCard>

              {/* Option 3: Registration Form */}
              <ModernOptionCard
                title="Option 3"
                subtitle="Registration Form"
                icon={<i className="fa fa-wpforms" />}
              >
                <div className="description-section">
                  <p>
                    Chant offers supporters groups the option to create a hosted
                    webpage with membership packages to collect annual dues,
                    offer merchandise and ask for donations.
                  </p>
                </div>

                <div className="link-section">
                  <div style={{ textAlign: "center" }}>
                    <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                      See examples:
                    </p>
                    <p style={{ marginBottom: "8px" }}>
                      <a
                        href="https://group.chant.fan/olscatlanta/join"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                        }}
                      >
                        Liverpool Atlanta
                      </a>
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <a
                        href="http://group.chant.fan/losangelesredarmy/join"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                        }}
                      >
                        Los Angeles Red Army
                      </a>
                    </p>
                  </div>
                </div>
                <div className="action-section">
                  <ChantButton
                    onClick={() => {
                      window.location.href = "/admin/members/packages/setup";
                    }}
                    loading={downloading}
                  >
                    Customize Form
                  </ChantButton>
                </div>
              </ModernOptionCard>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Non-members/Role - Option 4 */}
      <div className="onboard-section role-section">
        <div
          className="section-header"
          style={{
            backgroundColor:
              regCodeRole === "member"
                ? "var(--primary-background)"
                : "#000000",
          }}
        >
          {regCodeRole === "member"
            ? "Members"
            : regCodeRole === "fan"
              ? "Non-members"
              : "Set Role"}
          {!editStatus && regCodeRole && (
            <div className="header-edit-btn" onClick={onOpenModal}>
              <i className="fa fa-pencil" />
              <p>Edit</p>
            </div>
          )}
        </div>
        <div className="section-cards role-cards">
          <div className="modern-onboard-container">
            <div className="options-grid">
              {/* Option 4: Share Link / QR Code */}
              <ModernOptionCard
                title="Option 4"
                subtitle="Share Link / QR Code"
                icon={<i className="fa fa-qrcode" />}
              >
                <Option4
                  regCodeRole={regCodeRole}
                  showModal={showModal}
                  handleTabChange={handleTabChange}
                  saveRegCodeRole={saveRegCodeRole}
                  isRoleSaving={isRoleSaving}
                  onCloseModal={onCloseModal}
                  registrationLink={registrationLink}
                  isLoading={isLoading}
                  handleChangeRegistrationCode={handleChangeRegistrationCode}
                />
              </ModernOptionCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModernOnboardOptions;
